import React from 'react'
import PropTypes from 'prop-types'
import { AccountsApiContext } from '../contexts/AccountsApiContext'
import { withApi, extractData } from './ApiProvider'

export const withAccountsApi = ComponentToWrap => {
  const WrappedComponent = (props) => {
    return (
      <AccountsApiContext.Consumer>
        {value => (
          <ComponentToWrap {...props} accountsApi={value} />
        )}
      </AccountsApiContext.Consumer>
    )
  }

  WrappedComponent.displayName = `withAccountsApi(${ComponentToWrap.displayName || ComponentToWrap.name})`
  return WrappedComponent
}

const AccountsApiProviderComponent = (props) => {
  const { children, apiWrapper } = props

  const endpointsProvider = (baseURL) => {
    return {
      oauthAdminCustomerToken: `${baseURL}/oauth/admin/customer/token`,
      oauthAppToken: `${baseURL}/oauth/app/token`,
      oauthCustomerToken: `${baseURL}/oauth/customer/token`,
      getAccounts: `${baseURL}/api/accounts`
    }
  }

  const endpoints = endpointsProvider(process.env.ACCOUNTS_API_URL)
  const getAccounts = () => {
    return apiWrapper({
      method: 'get',
      url: endpoints.getAccounts

    }).then(extractData)
  }

  const accountsApi = {
    getAccounts: getAccounts
  }

  return (
    <AccountsApiContext.Provider value={accountsApi}>
      {children}
    </AccountsApiContext.Provider>
  )
}

AccountsApiProviderComponent.defaultProps = {
  children: null
}

AccountsApiProviderComponent.propTypes = {
  children: PropTypes.node,
  apiWrapper: PropTypes.func.isRequired
}

export const AccountsApiProvider = withApi(AccountsApiProviderComponent)
